const DEFAULT_TEMPLATE_VALUES = {
  affected_host: '',
  category_id: undefined,
  external_threats: '',
  generic: '',
  id: 0,
  internal: false,
  message: '',
  owner_id: undefined,
  priority_id: undefined,
  recommendation: '',
  recommendations: '',
  summary: '',
  team_queue: '',
  template: '',
  template_name: '',
  title: '',
  user_id: 0
};

export default DEFAULT_TEMPLATE_VALUES;
